module.exports = __webpack_public_path__ + "static/img/07 2.775a130.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotkeSlider/07 2.jpg
// module id = 1B3/
// module chunks = 0